"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _SecretRequirements = _interopRequireWildcard(require("./SecretRequirements"));
var _ResetPasswordStepResponse = _interopRequireDefault(require("../../api/auth/ResetPasswordStepResponse"));
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
const decorateSuccessMessage = msg => /*#__PURE__*/_react.default.createElement("div", {
  className: "field"
}, /*#__PURE__*/_react.default.createElement("div", {
  className: "control is-expanded has-icons-left"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "has-text-left"
}, msg)));
class ResetPasswordStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleOpen", () => {
      const {
        isOpen
      } = this.state;
      this.setState({
        isOpen: !isOpen
      });
    });
    _defineProperty(this, "measureStrength", secret => {
      let score = 0;
      let secretStrength;
      let secretStrengthValue = 0;
      if (!secret || secret === '') {
        this.setState({
          secretStrength: '',
          secretStrengthValue: '0'
        });
        return false;
      }
      const regexPositive = ['[A-Z]', '[a-z]', '[0-9]', '\\W'];
      regexPositive.forEach(regex => {
        if (new RegExp(regex).test(secret)) {
          score += 1;
        }
      });
      if (score === 4 && secret.length >= 10) {
        score += 1;
      }
      switch (score) {
        case 0:
        case 1:
        case 2:
        case 3:
          secretStrength = 'Weak';
          secretStrengthValue = '15';
          break;
        case 4:
          secretStrength = 'Good';
          secretStrengthValue = '60';
          break;
        case 5:
          secretStrength = 'Strong';
          secretStrengthValue = '100';
          break;
        default:
          secretStrength = '';
          secretStrengthValue = '0';
      }
      this.setState({
        secretStrength,
        secretStrengthValue
      });
      return secretStrengthValue !== '15' && secretStrengthValue !== '0';
    });
    this.state = {
      isLoading: false,
      userId: '',
      newSecret: undefined,
      newSecretErrorMessage: '',
      confirmSecret: undefined,
      confirmSecretErrorMessage: '',
      secretStrength: '',
      secretStrengthValue: 0,
      errorMessage: '',
      message: '',
      isOpen: false,
      workflowComplete: false
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  submit(e) {
    e.preventDefault();
    const {
      newSecret,
      confirmSecret
    } = this.state;
    if (!this.validateConfirmSecretSame(newSecret, confirmSecret)) {
      this.setState({
        confirmSecretErrorMessage: 'Confirm password does not match the new password'
      });
      return false;
    }
    if (!this.validatePasswordLength(newSecret, confirmSecret)) {
      this.setState({
        newSecretErrorMessage: 'New password must not be less then 10 and more than 24 characters. The specified password does not meet the minimum requirements.  Click the information icon below to view the minimum requirements.'
      });
      return false;
    }
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _ResetPasswordStepResponse.default();
    step.userId = this.state.userId;
    step.newSecret = Buffer.from(this.state.newSecret).toString('base64');
    step.confirmSecret = Buffer.from(this.state.confirmSecret).toString('base64');
    this.props.listener(this, step);
    return true;
  }
  change(e) {
    const userId = e.target.value;
    if (!this.validateLength(userId)) {
      this.setState({
        userId,
        errorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        userId,
        errorMessage: null
      });
    }
  }
  changeNewSecret(e) {
    const newSecret = e.target.value;
    if (!this.validateLength(newSecret)) {
      this.setState({
        newSecret,
        newSecretErrorMessage: 'This field is required for submission'
      });
    } else {
      const valMessage = (0, _SecretRequirements.getValidationMessage)(newSecret, 10, 24);
      this.setState({
        newSecret,
        newSecretErrorMessage: valMessage
      });
    }
    this.measureStrength(newSecret);
  }
  changeConfirmSecret(e) {
    const confirmSecret = e.target.value;
    if (!this.validateLength(confirmSecret)) {
      this.setState({
        confirmSecret,
        confirmSecretErrorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        confirmSecret,
        confirmSecretErrorMessage: null
      });
    }
  }
  validateButtonEnable(userId, newSecret, confirmSecret, secretStrength) {
    const validLen = this.validateLength(userId) && this.validateLength(newSecret) && this.validateLength(confirmSecret) && !(0, _SecretRequirements.getValidationMessage)(newSecret, 10, 24);
    return validLen && secretStrength !== 'Weak';
  }
  validateLength(val) {
    return val && val.length > 0;
  }
  validateConfirmSecretSame(newSecret, confirmSecret) {
    const validLen = this.validateLength(newSecret) && this.validateLength(confirmSecret);
    return validLen && newSecret === confirmSecret;
  }
  validatePasswordLength(newSecret) {
    return this.validateLength(newSecret) && newSecret.length >= 10 && newSecret.length <= 24;
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    const {
      userId,
      isOpen,
      newSecret,
      newSecretErrorMessage,
      confirmSecret,
      confirmSecretErrorMessage,
      rawErrorMessage,
      isLoading,
      workflowComplete,
      message,
      secretStrength,
      secretStrengthValue
    } = this.state;
    const disabled = !this.validateButtonEnable(userId, newSecret, confirmSecret, secretStrength) && !rawErrorMessage;
    let secretStrengthColor = '';
    if (secretStrength === 'Weak') {
      secretStrengthColor = 'is-danger';
    }
    if (secretStrength === 'Good') {
      secretStrengthColor = 'is-warning';
    }
    if (secretStrength === 'Strong') {
      secretStrengthColor = 'is-success';
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "resetSecretForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title"
    }, "Reset Password"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }), workflowComplete && message ? decorateSuccessMessage(message) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "text",
      placeholder: "Enter your current user id",
      id: "userId",
      name: "userId",
      size: "15",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      value: userId,
      autoComplete: "username",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "person")))), decorateErrorMessage(rawErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${newSecretErrorMessage && 'is-danger'}`,
      type: "password",
      placeholder: "Enter your new password",
      id: "newSecret",
      name: "newSecret",
      size: "15",
      onChange: e => this.changeNewSecret(e),
      onBlur: e => this.changeNewSecret(e),
      value: newSecret,
      autoComplete: "new-password",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), decorateErrorMessage(newSecretErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-8"
    }, /*#__PURE__*/_react.default.createElement("progress", {
      className: `progress ${secretStrengthColor}`,
      value: secretStrengthValue,
      max: "100",
      style: {
        display: 'inline-block'
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "column has-text-left"
    }, secretStrength)), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("a", {
      onClick: this.toggleOpen
    }, /*#__PURE__*/_react.default.createElement("span", {
      class: "icon-text"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "pb-2"
    }, "Password Requirements"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `table-cell--actionable${isOpen ? ' is-open' : ''}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-cell--actionable-container"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons has-text-link "
    }, "info "), /*#__PURE__*/_react.default.createElement("div", {
      className: "popover-menu content-left",
      style: {
        width: '300px',
        right: 'unset',
        left: '-125%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "triangle"
    }), /*#__PURE__*/_react.default.createElement(_SecretRequirements.default, {
      name: "password-hand",
      secret: newSecret,
      minLength: 10,
      maxLength: 24,
      key: newSecret
    }))))))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${confirmSecretErrorMessage && 'is-danger'}`,
      type: "password",
      placeholder: "Confirm your new password",
      id: "confirmSecret",
      name: "confirmSecret",
      size: "15",
      onChange: e => this.changeConfirmSecret(e),
      onBlur: e => this.changeConfirmSecret(e),
      value: confirmSecret,
      autoComplete: "new-password",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), decorateErrorMessage(confirmSecretErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Submit")))), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    })))));
  }
}
ResetPasswordStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(ResetPasswordStep);
//# sourceMappingURL=ResetPasswordStep.js.map